import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    aging(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'namaacc','tgl2', 'excludezero'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/advreport/aging${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
    },
    agingexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2', 'excludezero'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/advreport/agingexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `adv_aging_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    agingprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2', 'view', 'excludezero'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/agingprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/advance/advancegroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rekondb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/rekondb${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekondbexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/advreport/rekondbexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Adv_rekon_DB_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rekonkr(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/rekonkr${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekonkrexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/advreport/rekonkrexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Adv_rekon_CR_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxadvance(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['crewkey', 'crewinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/trxadvance${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxadvanceexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['crewkey', 'crewinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/advreport/trxadvanceexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `advance_trx_history.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxadvanceprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/advreport/trxadvanceprint${str}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
    },
    summary(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/summary${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    summaryexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/advreport/summaryexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `adv_summary_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    summaryprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2', 'view'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advreport/summaryprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};